import React from "react";
import {AButton, ADotLoader, AIcon, ATag} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {useDispatch, useSelector} from "react-redux";
import {refreshInvestigation} from "store/features/investigationSlice";
import {
  selectInvestigationDetailId,
  selectInvestigationHasMoreResults,
  selectInvestigationStatus
} from "store/selectors/investigationSelectors";
import css from "./InvestigationStatus.module.scss";

{
  /**
   * @todo Temporary component showing Investigation status.
   *   Final impl needs UX.
   */
}
const InvestigationStatus = () => {
  const dispatch = useDispatch();

  const id = useSelector(selectInvestigationDetailId);
  const hasMoreResults = useSelector(selectInvestigationHasMoreResults);
  const {pendingCount, completedCount, isComplete} = useSelector(
    selectInvestigationStatus
  );

  const handleRefresh = () => dispatch(refreshInvestigation({id}));

  const TagIcon = isComplete ? (
    <AIcon left>positive</AIcon>
  ) : (
    <ADotLoader className="my-0 mr-2" />
  );

  return (
    <>
      <ATag
        className={classNames("status-success my-0 mr-2", {
          [css.statusSuccess]: isComplete
        })}>
        {TagIcon}
        <div className="d-flex align-center">
          <div className="mr-2">
            <strong className="mr-1">Pending:</strong>
            <span>{pendingCount}</span>
          </div>
          <div>
            <strong className="mr-1">Completed:</strong>
            <span>{completedCount}</span>
          </div>
        </div>
      </ATag>
      {Boolean(pendingCount || hasMoreResults) && (
        <AButton secondary medium onClick={handleRefresh}>
          Refresh
        </AButton>
      )}
    </>
  );
};

export default InvestigationStatus;
